module.exports = __webpack_public_path__ + "img/icon_pencil.85af33f4.svg";